import React from 'react';
import { Route, Switch } from 'react-router';
import List from './scenes/List';
import View from './scenes/View';

const InterventionOrderRouter = ({ match }) => {
  return (
    <Switch>
      <Route path='/dashboard/intervention-orders/new' exact component={View} />
      <Route path='/dashboard/intervention-orders/:id' exact component={View} />
      <Route path='/dashboard/intervention-orders' exact component={List} />
    </Switch>
  );
};

export default InterventionOrderRouter;
